module.exports = __webpack_public_path__ + "static/media/person4.07656a35.jpg";